import { PublicClientApplication } from '@azure/msal-browser'

/** Instância singleton do MSAL, criada sob demanda */
let msalInstance = null

/**
 * Inicializa o MSAL com as configurações do cliente
 * @param {string} clientId - Client ID do app registration no Azure AD
 * @param {string} tenantId - Tenant ID do cliente no Azure AD
 */
export async function initMsal(clientId, tenantId) {
  msalInstance = new PublicClientApplication({
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: window.location.origin
    }
  })

  await msalInstance.initialize()
}

/**
 * Limpa a sessão MSAL local (sem redirecionar para logout da Microsoft)
 */
export function clearMsalCache() {
  ;[sessionStorage, localStorage].forEach((storage) => {
    Object.keys(storage)
      .filter((key) => key.startsWith('msal.') || key.includes('login.windows'))
      .forEach((key) => storage.removeItem(key))
  })
}

/**
 * Abre popup de login da Microsoft e retorna o accessToken
 * @returns {Promise<string>} accessToken retornado pela Microsoft
 */
export async function loginWithMicrosoft() {
  const response = await msalInstance.loginPopup({
    scopes: ['https://graph.microsoft.com/User.Read'],
    prompt: 'login'
  })

  return response.accessToken
}
